import { NeoModel, ModelBase, Rules, Attributes } from "@singularsystems/neo-core";
import { TimeZoneFormat } from "@singularsystems/neo-core/dist/Misc";

@NeoModel
export default class StaticExportFileSpecLookup extends ModelBase {

    public staticExportFileSpecId: number = 0;

    @Rules.Required()
    @Rules.StringLength(100)
    public exportName: string = "";

    @Rules.Required()
    @Rules.StringLength(200)
    public exportReportReference: string = "";

    @Rules.Required()
    @Rules.StringLength(10)
    public format: string = "";

    @Attributes.Date(TimeZoneFormat.None)
    @Rules.Required()
    public activeStartDate: Date | null = null;

    @Attributes.Date(TimeZoneFormat.None)
    public activeEndDate: Date | null = null;

    public columnCount: number = 0;

    public isActiveInd: boolean = false;

    public latestVersionOfExportFileSpecId: number = 0;

    public propertiesConcatenated: string | null = null;

    public isCreatedFromPreviousVersion: boolean = false;

}